;(function ($) {
    "use strict";

    // Constructor
    var DropdownType = function (elem, model, context) {
        this.$elem = elem;
        this._model = model;
        this._context = context || this.$elem.data('dropdownContext');
        this._model.attrs = this.$elem.data('attrs');
        this._template = Handlebars.templates['partials/common/dropdown'];
        this._render();

        this._$select = this.$elem.find('[data-control="'+ this._context +'"]');
        this._selectedIndex = this._$select[0].selectedIndex;
        this._selectedValue = this._$select[0].options[this._selectedIndex].value;

        this._setupEvents = (function (_this) {
            _this.$elem.on('change', '.dd-select', function (evt) {
                evt.preventDefault();

                var elem = evt.target,
                    $elem = $(elem),
                    detail = {
                        'context': elem.id, 'value': $elem.val()
                    };
                _this._selectedValue = $elem.val();
                _this._selectedIndex = $elem[0].selectedIndex;

                uitk.publish("selection.changed.event", detail);
            });
        })(this);
    };

    // Prototype
    DropdownType.prototype = {
        constructor: DropdownType,
        _render: function () {
            this.$elem.html('');
            this.$elem.html(this._template(this._model));
        },
        getSelectedValue : function(){
            return this._selectedValue;
        },
        getSelectedIndex : function(){
            return this._selectedIndex;
        },
        setSelectedValue : function(selectedValue){
        	this._selectedValue = selectedValue;
        },
        setSelectedIndex : function(selectedIndex){
        	this._selectedIndex = selectedIndex;
        },
        updateValues: function (model) {
            this._model = model;
            this._render(model);
        }
    };

    $.fn.dropdownType = function (model, context) {
        return new DropdownType(this, model, context);
    }
})(window.jQuery);
